import { render, staticRenderFns } from "./GatewayDetailBreakdownLine.vue?vue&type=template&id=18039546&"
import script from "./GatewayDetailBreakdownLine.vue?vue&type=script&lang=ts&"
export * from "./GatewayDetailBreakdownLine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports